export default "__VITE_ASSET__BkqR$8lO__"